import { http } from 'common/helpers/axios/axios-helper';
import { SignInAuditModel, SignInAuditQuery } from '../model/sign-in-audit.model';
import { SuccessFilter } from 'common/types/success-filter.model';

const basePath = 'user/signin/audit';

async function getDataList(query: SignInAuditQuery) {
	const queryParams = [];
	
	if (query.success && query.success !== SuccessFilter.All) {
		const successBoolean = query.success === SuccessFilter.Yes;
		queryParams.push(`success=${successBoolean}`);
	  }

	if (query.route !== null && query.route !== undefined) { 
		queryParams.push(`route=${encodeURIComponent(query.route)}`);
	}

	queryParams.push(`pageNumber=${query.pageNumber}`);
	queryParams.push(`pageSize=${query.pageSize}`);
	
	if (query.orderBy) {
	  queryParams.push(`orderBy=${query.orderBy}`);
	}
	if (query.order) {
	  queryParams.push(`order=${query.order}`);
	}
  
	const queryString = queryParams.join('&');
	const response = await http.get<SignInAuditModel>(`${basePath}?${queryString}`);
	
	return response || { 
	  data: { items: [], totalCount: 0, pageNumber: query.pageNumber, pageSize: query.pageSize },
	  hasErrors: true 
	};
  }
  
export const SignInAuditService = { 
	getDataList
  };
